import { all, call, fork } from 'redux-saga/effects';

import { i18nSagas } from '!core/features';
import {
  fundsSagas,
  publicOfferSagas,
  tradingSagas,
  walletSagas,
} from '!views/index';
import { webAreasSagas } from '!views/Market';
import { stockExchangeSagas } from '!views/Market/StockExchange/_marketStockExchange.sagas';
import {
  authSagas,
  loginFlowSaga,
  logoutSagas,
  onboardingSagas,
  otpSagas,
} from '»components/Auth';
import { generalConditionsSagas } from '»components/Auth/GeneralConditions/generalConditions.sagas';
import { trlTopInstrumentsSagas } from '»components/index';
import { menusSagas } from '»components/Menus';
import { questionnaireSagas } from '»components/Questionnaire/redux';

import { request, tracerSagas } from '..';
import { accountBalanceSagas } from './accountBalance/accountBalance.sagas';
import { dbConfigurationsSagas } from './dbConfigurations/dbConfigurations.sagas';
import { userAttributesSagas } from './userAttributes';
import { userContactsSagas } from './userContacts/userContacts.sagas';
import { userInfoSagas } from './userInfo/userInfo.sagas';
import { setFavInstrumentSagas } from './userInstruments/userInstruments.sagas';
import { userSecuritiesAccountsSagas } from './userSecuritiesAccounts/userSecuritiesAccounts.sagas';

export const appSagas = function* () {
  try {
    yield call(request.setDefaultHeaders);
    yield all([
      fork(loginFlowSaga),
      fork(logoutSagas),
      fork(authSagas),
      fork(onboardingSagas),
      fork(menusSagas),
      fork(tracerSagas),
      fork(i18nSagas),
      fork(walletSagas),
      fork(tradingSagas),
      fork(publicOfferSagas),
      fork(userInfoSagas),
      fork(userSecuritiesAccountsSagas),
      fork(accountBalanceSagas),
      fork(stockExchangeSagas),
      fork(dbConfigurationsSagas),
      fork(setFavInstrumentSagas),
      fork(userContactsSagas),
      fork(generalConditionsSagas),
      fork(userAttributesSagas),
      fork(trlTopInstrumentsSagas),
      fork(fundsSagas),
      fork(webAreasSagas),
      fork(otpSagas),
      fork(questionnaireSagas),
    ]);
  } catch {}
};
